module.exports = __webpack_public_path__ + "img/64.601e3752.jpg";